import React from "react";

import "./footer.css";
function Footer() {
  return (
    <div className="Footer">Copyright © 2025 NEWSTRAIL All Rights Reserved</div>
  );
}

export default Footer;
